import * as api from '../../services/country/api_country';
import { browserHistory } from 'react-router';
import { delay, call, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import * as common from '../sagasCommon';
import * as apiCommon from '../../services/apiCommon';
import * as DocType from '../../constants/constant_doc_types';
import * as SagasType from '../../constants/constant_saga_types';

export function* fetchListCountrySaga(feathersApp) {
	yield takeLatest('FETCH_LIST_COUNTRY', callFetchListCountry, feathersApp);
}

function* callFetchListCountry(feathersApp, action) {
	const { filters, silent } = action;
	yield common.showProgressListTable(silent);
	try {
		const dataParams = {
			filters,
			list_type: DocType.COUNTRY
		};
		const tableData = yield call(apiCommon.getDocs, feathersApp, dataParams);
		yield call(common.doneListTable, { rows: tableData.data, total_rows: tableData.total });
	} catch (error) {
		yield common.showErrorListTable(error);
	}
}

export function* saveCountrySaga(feathersApp) {
	yield takeEvery("SAVE_COUNTRY", callSaveCountry, feathersApp);
}
function* callSaveCountry(feathersApp, action) {
	const { tenant, user } = yield select();
	try {
		yield put({ type: 'SAVE_RECORD_INPROGRESS' });

		const params = { tenant, user, data: action.data };
		const result = yield call(api.saveCountry, feathersApp, params);
		yield common.doneSaveRecord(result, 'Country was saved');
		yield put({
			type: SagasType.SIMPLE_FORM_SET_DATA,
			data: result
		});		
		yield callFetchListCountry(feathersApp, { silent: true });

	} catch (e) {
		yield common.showErrorSaveRecord(e);
	}
}

export function* deleteCountryFromListSaga(feathersApp) {
	yield takeEvery('DELETE_COUNTRY_FROM_LIST', callDeleteCountryFromList, feathersApp);
}

function* callDeleteCountryFromList(feathersApp, action) {
	yield deleteCountry(feathersApp, action);
	yield delay(2000);
	yield callFetchListCountry(feathersApp, { silent: true });
}

function* deleteCountry(feathersApp, action) {
	yield put({ type: 'DELETE_RECORD_INPROGRESS' });
	try {
		const { id } = action;
		let result = null;
		if (id) {
			const state = yield select();
			const { tenant, user } = state;
			const params = { tenant, user, id };
			result = yield call(api.deleteCountry, feathersApp, params);
			yield put({ type: "DELETE_RECORD_DONE", payload: { id, docType: DocType.COUNTRY } });
			yield callFetchListCountry(feathersApp, { silent: true });
		}
		return result;
	} catch (error) {
		yield put({ type: 'DELETE_RECORD_ERROR', error })
	}
}

export function* deleteCountrySaga(feathersApp) {
	yield takeEvery('DELETE_COUNTRY', callDeleteCountry, feathersApp);
}

function* callDeleteCountry(feathersApp, action) {
	const result = yield deleteCountry(feathersApp, action);
	yield delay(2000);
	if (result) {
		browserHistory.push('/admin/country');
	}
}

export function* fetchCountryForEditSaga(feathersApp) {
	yield takeEvery('FETCH_COUNTRY_BY_ID', callFetchCountryForEdit, feathersApp);
}

function* callFetchCountryForEdit(feathersApp, action) {
	const { tenant, user } = yield select();
	const { id } = action;
	const docType = DocType.COUNTRY;
	try {
		if (id) {
			yield put({ type: "FETCH_DATA_BY_ID_INPROGRESS", payload: { docType, id } });
			const fetchParams = { tenant, user, id };
			const doc = yield call(api.fetchCountryById, feathersApp, fetchParams);
			yield common.doneDataById(doc);
			yield put({
				type: SagasType.SIMPLE_FORM_SET_DATA,
				data: doc
			});
		}
	} catch (error) {
		yield put({ type: "FETCH_DATA_BY_ID_ERROR", error: error });
	}
}
